var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgModelIsolate = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7 1.18v6.94l-.5-.25-.5.25-4.48 2.2-.04.02-.48-.24v-.51l5-2.46v-5.95l.5-.21z",
    opacity: 0.33
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m8 12.5714h3.4286v3.4286h-3.4286zm0-4.5714v3.4286h3.4286v-3.4286zm2.8571 2.8571h-2.2857v-2.2857h2.2857zm1.7143-2.8571v3.4286h3.4286v-3.4286zm2.8572 2.8571h-2.2857v-2.2857h2.2857zm-2.8572 1.7143v3.4286h3.4286v-3.4286zm2.8572 2.8572h-2.2857v-2.2857h2.2857zm-8.9286-15.4286-6.5 3.2v7.47l6.5 3.2.5-.25v-6.77l5-2.46v2.61h1v-3.8zm-.5 12.52-4.48-2.2-.52-.26v-5.67l5 2.46zm1-6.74-.5.25-.5-.25-4.64-2.28 4.64-2.28.5-.25.5.25 4.64 2.28z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgModelIsolate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/model-isolate.eb01776298f36b2f469423614dd83712.svg";